type Position = { x: number; y: number };

/**
 * Resolves the final x/y position of a node after a drag event.
 * Falls back to dataPosition coordinates when nodePosition contains NaN values.
 * Returns null when neither source has valid (non-zero, non-NaN) coordinates.
 */
export function resolveNodeDragPosition(
  nodePosition: Position,
  dataPosition: Position | undefined
): Position | null {
  if (
    (!nodePosition.x || !nodePosition.y) &&
    (!dataPosition?.x || !dataPosition?.y)
  ) {
    return null;
  }

  return {
    x: isNaN(nodePosition.x)
      ? (dataPosition?.x ?? nodePosition.x)
      : nodePosition.x,
    y: isNaN(nodePosition.y)
      ? (dataPosition?.y ?? nodePosition.y)
      : nodePosition.y
  };
}
